export const complianceExamples = ['WCAG 2.2', 'ADA', 'EAA', 'Section 508', 'AODA'];

export type ScanInputSectionProps = {
  onScan: (websiteUrl: string) => Promise<void>;
};

export enum ScanUrlType {
  Admin = 'admin',
  Public = 'public',
}

export type ScanUrlProps = {
  type?: ScanUrlType;
};
